export default __webpack_public_path__ + "static/media/baleine.d54644ee.png";